import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import { Loader } from '@/components/atomic/Loader'
import { PageContainer } from '@/components/atomic/PageContainer'
import { PageMetaData } from '@/components/atomic/PageMetaData'
import { Breadcrumbs } from '@/components/styleguide/Breadcrumbs'
import { ChatWidget } from '@/components/styleguide/ChatWidget'
import { Header } from '@/components/styleguide/Header'
import { SearchFormCTA } from '@/components/views/SearchFormCTA'
import { ROUTES } from '@/lib/routes'
import { getPageContentItemService } from '@/lib/services/pageService'

const ContentPageBody = dynamic(() => import('@/components/views/ContentPageBody'))

const BlogArticlePage = ({ article }) => {
  dayjs.extend(advancedFormat)

  useEffect(() => {
    if (typeof window.ttq !== 'undefined') {
      window.ttq.track('ViewContent', {
        /* eslint-disable */
        content_id: `${article.content.title}`,
        content_type: 'product',
        content_name: `${article.content.title}`,
        /* eslint-enable */
        quantity: 1,
        value: null,
        price: null,
        currency: 'GBP',
      })
    }
  }, [article.content.title])

  if (!article) {
    return (
      <div className="blog-page__content-loader">
        <Loader />
      </div>
    )
  }

  return (
    <>
      <PageMetaData
        title={`${article.content.title} | LeaseLoco`}
        pageTitle={`${article.content.title} | LeaseLoco`}
        description={
          article.content.metaDescription
            ? article.content.metaDescription
            : article.content.description.replace(/<[^>]*>?/gm, '')
        }
        pageUrl={`/blog/${article.urlKey}`}
        image={article.content.thumbnail}
        blogArticle={article.content}
      />
      <ChatWidget />
      <Header
        backgroundColor="white"
        backButtonUrl={ROUTES.blogPage.url}
      />
      <PageContainer containerClass="container--blog-article">
        <Breadcrumbs
          className="content-breadcrumbs"
          crumbs={[
            {
              label: 'Home',
              slug: ROUTES.homePage.url,
            },
            {
              label: 'Leasing blog',
              slug: ROUTES.blogPage.url,
            },
            {
              label: article.content.title,
              slug: null,
            },
          ]}
        />
        <ContentPageBody article={article} />
      </PageContainer>
      <SearchFormCTA />
    </>
  )
}

export default BlogArticlePage

export const getServerSideProps = async context => {
  try {
    const article = await getPageContentItemService({
      type: 'BLOG',
      urlKey: context.params.slug,
    })

    return {
      props: {
        article,
      },
    }
  } catch (err) {
    return {
      notFound: true,
    }
  }
}
